export const KP_CLASSES_MAP = {
  business: 'Бизнес',
  comfort: 'Комфорт',
  economy: 'Эконом',
  elite: 'Элитный',
};
